export default __webpack_public_path__ + "static/media/11392453.svg";